const ONBOARDING_KEYS = {
  CURRENT_STEP: 'onboarding_current_step',
  DATA: 'onboarding_data',
  USER_EMAIL: 'onboarding_user_email',
} as const;

export const OnboardingStorage = {
  saveStep: (step: number): void => {
    localStorage.setItem(ONBOARDING_KEYS.CURRENT_STEP, step.toString());
  },

  getStep: (): number => {
    const savedStep = localStorage.getItem(ONBOARDING_KEYS.CURRENT_STEP);
    const step = savedStep ? parseInt(savedStep, 10) : 0;
    return step >= 0 && step <= 5 ? step : 0;
  },

  saveData: (data: any): void => {
    localStorage.setItem(ONBOARDING_KEYS.DATA, JSON.stringify(data));
  },

  getData: (): any | null => {
    const savedData = localStorage.getItem(ONBOARDING_KEYS.DATA);
    if (savedData) {
      try {
        return JSON.parse(savedData);
      } catch (error) {
        console.warn('Failed to parse saved onboarding data');
        return null;
      }
    }
    return null;
  },

  saveUserEmail: (email: string): void => {
    localStorage.setItem(ONBOARDING_KEYS.USER_EMAIL, email);
  },

  getUserEmail: (): string | null => {
    return localStorage.getItem(ONBOARDING_KEYS.USER_EMAIL);
  },

  clearAll: (): void => {
    Object.values(ONBOARDING_KEYS).forEach(key => {
      localStorage.removeItem(key);
    });
  },

  clearForUserChange: (newUserEmail: string): boolean => {
    const savedUserEmail = OnboardingStorage.getUserEmail();
    if (savedUserEmail && savedUserEmail !== newUserEmail) {
      OnboardingStorage.clearAll();
      return true;
    }
    return false;
  },

  markOnboardingCompleted: (userEmail: string): void => {
    const onboardingCompletedKey = `onboarding_completed_${userEmail}`;
    localStorage.setItem(onboardingCompletedKey, 'true');
  },

  needsOnboarding: (user: any): boolean => {
    const onboardingCompletedKey = `onboarding_completed_${user.email}`;
    const hasCompletedOnboardingBefore = localStorage.getItem(onboardingCompletedKey) === 'true';
    
    if (hasCompletedOnboardingBefore) {
      return false;
    }
    
    const hasBasicProfile = !!(user.preferred_language && user.user_type);
    
    const hasActiveOnboarding = !!(
      localStorage.getItem(ONBOARDING_KEYS.CURRENT_STEP) || 
      localStorage.getItem(ONBOARDING_KEYS.DATA)
    );
    const onboardingUserEmail = localStorage.getItem(ONBOARDING_KEYS.USER_EMAIL);
    const isCurrentUserOnboarding = onboardingUserEmail === user.email;
    
    return user.is_new_user === true || 
           (!hasBasicProfile && !hasCompletedOnboardingBefore) || 
           (hasActiveOnboarding && isCurrentUserOnboarding);
  },
};